
const TransactionActionTypes = {
    FETCH_TRANSACTION_START: "FETCH_TRANSACTION_START",
    FETCH_TRANSACTION_SUCCESS: "FETCH_TRANSACTION_SUCCESS",
    FETCH_TRANSACTION_FAILURE: "FETCH_TRANSACTION_FAILURE",
  };
  
  export default TransactionActionTypes;
  